import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProgramAgregatedMilstonesComponent } from './program-agregated-milstones.component';

const routes: Routes = [
  {
    path: '',
    component: ProgramAgregatedMilstonesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProgramAgregatedMilstonesRoutingModule { }
